import React, { useState } from "react";
import { db, storage } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

function StudentForm() {
  const [formData, setFormData] = useState({
    name: "",
    guardianname: "",
    mobile: "",
    branch: "",
    address: "",
    course: "",
    schoolname: "",
    education: "",
  });

  const [photo, setPhoto] = useState(null);
  const [signature, setSignature] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Upload file and return URL
  const uploadFile = async (file, folder) => {
    const fileRef = ref(
      storage,
      `${folder}/${Date.now()}_${file.name}`
    );
    await uploadBytes(fileRef, file);
    return await getDownloadURL(fileRef);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!photo || !signature) {
      alert("Photo & Signature required");
      return;
    }

    try {
      const photoURL = await uploadFile(photo, "student_photos");
      const signatureURL = await uploadFile(signature, "student_signatures");

      await addDoc(collection(db, "student_form_data"), {
        ...formData,
        photoURL,        // Excel link
        signatureURL,    // Excel link
        createdAt: serverTimestamp(),
        createdAtDate: new Date(),
      });

      alert("Application submitted successfully!");

      setFormData({
        name: "",
        guardianname: "",
        mobile: "",
        address: "",
        course: "",
        branch: "",
        schoolname: "",
        education: "",
      });
      setPhoto(null);
      setSignature(null);
    } catch (error) {
      console.error(error);
      alert("Submission failed");
    }
  };

  return (
    <div className="card p-3">
      <h3 className="text-center text-primary">
        <b>Student Application Form</b>
      </h3>

      <form onSubmit={handleSubmit}>
        <div className="row">

          <div className="col-md-6 mt-2">
            <input
              type="text"
              name="name"
              className="form-control"
              placeholder="Student Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mt-2">
            <input
              type="text"
              name="guardianname"
              className="form-control"
              placeholder="Guardian Name"
              value={formData.guardianname}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mt-2">
            <input
              type="tel"
              name="mobile"
              className="form-control"
              placeholder="Mobile Number"
              pattern="[0-9]{10}"
              maxLength="10"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>
             <div className="col-md-6 mt-2">
            <input
              type="text"
              name="education"
              className="form-control"
              placeholder="Education qualification"
           
              value={formData.education}
              onChange={handleChange}
              required
            />
          </div>
   <div className="col-md-6 mt-2">
            <input
              type="text"
              name="schoolname"
              className="form-control"
              placeholder="School name"
         
              value={formData.schoolname}
              onChange={handleChange}
              required
            />
          </div>




          <div className="col-md-6 mt-2">
            <select
              name="course"
              className="form-control"
              value={formData.course}
              onChange={handleChange}
              required
            >
              <option value="">Select Course</option>
              <option value="Basic Computer">Basic Computer</option>
              <option value="DCA">DCA</option>
              <option value="ADCA">ADCA</option>
              <option value="Tally">Tally</option>
              <option value="Web Design">Web Design</option>
            </select>
          </div>
  <div className="col-md-6 mt-2">
            <select
              name="branch"
              className="form-control"
              value={formData.branch}
              onChange={handleChange}
              required
            >
              <option value="">Select Branch</option>
              <option value="Krishnagar">Krishnagar</option>
              <option value="Burdwan">Burdwan</option>
              <option value="Durgapur">Durgapur</option>
              <option value="Kalyani">Kalyani</option>
            </select>
          </div>
          <div className="col-md-12 mt-2">
            <textarea
              name="address"
              className="form-control"
              placeholder="Address"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mt-2">
            <label>Photo</label>
            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={(e) => setPhoto(e.target.files[0])}
              required
            />
          </div>

          <div className="col-md-6 mt-2">
            <label>Signature</label>
            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={(e) => setSignature(e.target.files[0])}
              required
            />
          </div>

        </div>

        <center>
          <button className="btn btn-primary mt-3" type="submit">
            Submit Application
          </button>
        </center>
      </form>
    </div>
  );
}

export default StudentForm;
